//tab统计
import { apiAxios } from "@/api/axios";
import base from '../config'
let baseURL = base.baseURL
export default {
 
  //左侧菜单的数量统计
  menuLeftNum: (data) => apiAxios('post', baseURL + '/data.menuLeftNum', data),
  //待确认汇款列表统计
  unConfirmListNum: (data) => apiAxios('post', baseURL + '/data.tab.unConfirmListNum', data),
  //退换货列表数量统计
  purchaseRefundListNum: (data) => apiAxios('post', baseURL + '/data.tab.purchaseRefundListNum', data),
  //违禁商品监控列表数量统计
  forbidGoodsListNum: (data) => apiAxios('post', baseURL + '/data.tab.forbidGoodsListNum', data),
  //申请废弃列表数量统计
  wmsToDiscardListNum: (data) => apiAxios('post', baseURL + '/data.tab.wmsToDiscardListNum', data),
  //仓库货架列表统计
  wmsShelfNum: (data) => apiAxios('post', baseURL + '/data.tab.wmsShelfNum', data),
  //仓库区域列表统计
  wmsAreaNum: (data) => apiAxios('post', baseURL + '/data.tab.wmsAreaNum', data),
  //客户提现列表统计
  clientCashOutNum: (data) => apiAxios('post', baseURL + '/data.tab.clientCashOutNum', data),
  //交易号付款列表统计
  purchaseWaitPayListNum: (data) => apiAxios('post', baseURL + '/data.tab.purchaseWaitPayListNum', data),
  //人工登记汇款列表统计
  financialStoreListNum: (data) => apiAxios('post', baseURL + '/data.tab.financialStoreListNum', data),
  //仓库库存(普通,辅料,备品)列表数量统计
  wmsStockListNum: (data) => apiAxios('post', baseURL + '/data.tab.wmsStockListNum', data),
  //仓库-收费仓库-列表数量统计
  stockListChargeNum: (data) => apiAxios('post', baseURL + '/data.tab.stockListChargeNum', data),
  //待确认汇款列表统计
  unConfirmListNum: (data) => apiAxios('post', baseURL + '/data.tab.unConfirmListNum', data),
  //配送单翻译列表统计
  porderTranslateNum: (data) => apiAxios('post', baseURL + '/data.tab.porderTranslateNum', data),
  //配送单待装箱列表统计
  porderPackNum: (data) => apiAxios('post', baseURL + '/data.tab.porderPackNum', data),
  //配送单待报价列表统计
  porderOfferNum: (data) => apiAxios('post', baseURL + '/data.tab.porderOfferNum', data),
  //配送单待支付列表统计
  porderWaitPayNum: (data) => apiAxios('post', baseURL + '/data.tab.porderWaitPayNum', data),
  //配送单待出货列表统计
  porderWaitDeliveryNum: (data) => apiAxios('post', baseURL + '/data.tab.porderWaitDeliveryNum', data),
  //配送单已出货列表统计
  porderDeliveryNum: (data) => apiAxios('post', baseURL + '/data.tab.porderDeliveryNum', data),
  // 待拍下商品列表统计
  purchaseListNum: (data) => apiAxios('post', baseURL + '/data.tab.purchaseListNum', data),
  // 不良品列表数量统计
  badListNum: (data) => apiAxios('post', baseURL + '/data.tab.badListNum', data),
  // 问题商品列表数量统计
  problemGoodsListNum: (data) => apiAxios('post', baseURL + '/data.tab.problemGoodsListNum', data),
  // 搜索关键词Table数量
  searchKeywordsTable: (data) => apiAxios('post', baseURL + '/config.translate.searchKeywordsTable', data),
  // 商品规格属性Table数量
  goodsDetailTable: (data) => apiAxios('post', baseURL + '/config.translate.goodsDetailTable', data),
  
  
}